export default "__VITE_ASSET__CUFR2P86__"